module.exports = __webpack_public_path__ + "static/media/exit.dfc7a90e.svg";